import { boolean, RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamAudioUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamAudioUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamAudioUpdateRequestDTORaw) {
    JsonSchemaValidator.assert(
      RoomStreamAudioUpdateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId", "isEnabled"],
      properties: {
        roomId,
        streamId,
        isEnabled: boolean
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamAudioUpdateRequestDTORaw {
  roomId: RoomId;
  streamId: StreamId;
  isEnabled: boolean;
}
